import React from 'react';
import { RouterProvider } from 'react-router-dom';

import { SiteBadlyConfigured } from '@/components/site-badly-configured';
import { setClientId } from '@/stores/qng-data-store';

import router from './router';

/**
 * The base Router for QNG
 */
export function AppRouter() {
  const [showDevtools, setShowDevtools] = React.useState(false);

  React.useEffect(() => {
    window.toggleDevtools = () => setShowDevtools((old) => !old);

    /**
     * When the site first loads, we should have the dynamic configuation.js
     * file loaded by now (as it'll load well before any React runs in theory)
     * So update the local datastore with that value.
     */
    setClientId(window.globalQngConfig?.clientId);
  }, []);

  /**
   * If the configuration.js failed to load OR is missing the apiUrl then there
   * really is nothing we can do without the user hard refreshing the page to try
   * again.
   */
  const missingApiUri = !window.globalQngConfig?.apiUri;
  if (missingApiUri) {
    return <SiteBadlyConfigured />;
  }

  return (
    <>
      {showDevtools && (
        <React.Suspense fallback={false}>
          <ReactQueryDevtoolsProduction />
        </React.Suspense>
      )}
      <RouterProvider router={router} future={{ v7_startTransition: true }} />
    </>
  );
}

const ReactQueryDevtoolsProduction = React.lazy(() =>
  import('@tanstack/react-query-devtools/build/modern/production.js').then(
    (d) => ({ default: d.ReactQueryDevtools }),
  ),
);
